// extracted by mini-css-extract-plugin
export default {"inputs":"SizingConstraints_inputs__lGo-0","highlightedData":"SizingConstraints_highlightedData__5hezu"};